module.exports = __webpack_public_path__ + "static/assets/3eff757ccf6c1b4424f5c2ae8791051c.svg";